import { useMemo } from "react";
import Card, { Bar } from "./Card.jsx";
import { getAreaPatterns } from "../../lib/lotto.js";

export default function AreaPatterns({ rows }) {
  const patterns = useMemo(() => getAreaPatterns(rows, 16), [rows]);
  const max = patterns[0]?.[1] ?? 1;

  return (
    <Card
      title="번호군 패턴 빈도"
      subtitle={`16회 이상 등장한 ${patterns.length}개 패턴`}
      span={1}
    >
      <p className="muted" style={{ fontSize: 11 }}>
        패턴 코드: 1=1~10, 2=11~20, 3=21~30, 4=31~40, 5=41~45 (예: "112344")
      </p>
      {patterns.slice(0, 12).map(([code, count, pct, lastIdx]) => (
        <Bar
          key={code}
          value={count}
          max={max}
          label={
            <span style={{ fontFamily: "monospace" }}>
              {code} <span className="muted">({pct})</span>
            </span>
          }
        />
      ))}
    </Card>
  );
}
